import React from "react";
import { FaCloudDownload } from "react-icons/lib/fa";

import leftImage from "../assets/images/building-outdoor1.jpg";

const About = () => (
  <section id="about">
    <div className="row">
      <div className="six columns">
        <img src={leftImage} alt="" />
      </div>
      <div className="six columns main-col">
        <h2>About the property</h2>
        <p>
          Downtown Health Centre is a professionally maintained modern building
          conveniently located in downtown Corner Brook. Ample parking is provided
          on three different levels, one for each floor of the building.
        </p>
        <p>
          Tenants are offered attractive lease rates with reasonable terms and
          conditions. Please contact us for more information.
        </p>
      </div>
    </div>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js